{
  "menu": {
    "title": "Marcadores"
  },
  "title": "Marcadores",
  "subtitle": "Las pantallas que muestran el código de marcación en cada sede.",
  "fields": {
    "name": "Nombre",
    "site": "Sede",
    "status": "Estado",
    "lastSignal": "Última señal",
    "device": "Dispositivo",
    "browser": "Navegador",
    "platform": "Plataforma",
    "transport": "Transporte",
    "startedAt": "Sesión desde",
    "keyDelivered": "Clave entregada",
    "activatedAt": "Activado el",
    "disabledAt": "Deshabilitado el",
    "createdAt": "Creado el"
  },
  "status": {
    "ONLINE": "En línea",
    "OFFLINE": "Sin conexión",
    "DISABLED": "Deshabilitado"
  },
  "statusReason": {
    "ADMIN": "Deshabilitado por un administrador",
    "SITE_INACTIVE": "Sede inactiva",
    "NEVER_ACTIVATED": "Sin activar"
  },
  "platform": {
    "ios": "iPad",
    "android": "Android",
    "desktop": "Escritorio",
    "other": "Otro"
  },
  "transport": {
    "ws": "WebSocket",
    "sse": "SSE"
  },
  "filters": {
    "search": "Buscar",
    "searchPlaceholder": "Nombre del marcador",
    "site": "Sede",
    "siteAll": "Todas las sedes",
    "status": "Estado",
    "statusAll": "Todos los estados"
  },
  "actions": {
    "new": "Nuevo marcador",
    "issueCode": "Generar código",
    "edit": "Editar",
    "regenerate": "Regenerar"
  },
  "table": {
    "caption": "Marcadores de la empresa",
    "actions": "Acciones",
    "none": "—",
    "device": "{platform} · {browser}",
    "secondsAgo": "hace {seconds} s",
    "neverSignal": "Sin señal"
  },
  "empty": {
    "title": "Todavía no hay marcadores",
    "description": "Crea el primero para convertir una tablet de recepción en el marcador de la sede.",
    "noResults": "Ningún marcador coincide con estos filtros.",
    "noSitesTitle": "Primero necesitas una sede activa",
    "noSitesDescription": "Un marcador siempre vive en una sede activa: crea o reactiva una para poder registrarlo.",
    "noSitesAction": "Ir a Sedes"
  },
  "form": {
    "createTitle": "Nuevo marcador",
    "editTitle": "Editar marcador",
    "description": "Ponle un nombre que se entienda en la sede: «Recepción», «Puerta de planta».",
    "nameHelp": "Hasta 60 caracteres. Único dentro de la sede.",
    "siteHelp": "Solo sedes activas de tu alcance.",
    "sitePlaceholder": "Elige una sede",
    "errors": {
      "name": "Escribe un nombre de hasta 60 caracteres.",
      "nameTaken": "Ya existe un marcador con ese nombre en esta sede.",
      "site": "Elige una sede activa."
    }
  },
  "code": {
    "title": "Código de activación",
    "description": "Escríbelo en Fermin Marker, en la pantalla «{name}» de {site}.",
    "warning": "Cópialo antes de cerrar: por seguridad no se volverá a mostrar.",
    "label": "Código de activación",
    "validity": "Válido {minutes} minutos · un solo uso",
    "expires": "Vence el {date} (hora de {site}).",
    "regenerate": "Regenerar",
    "regenerateHelp": "Al regenerar, el código anterior deja de servir.",
    "done": "Listo"
  },
  "unlink": {
    "action": "Desvincular",
    "title": "Desvincular «{name}»",
    "description": "La pantalla dejará de operar y volverá a pedir un código de activación.",
    "note": "Te mostraremos el código nuevo una sola vez, apenas confirmes. Las marcaciones ya registradas no se tocan.",
    "noCode": "Este marcador está deshabilitado, así que no emitimos un código nuevo: habilítalo primero y ahí te daremos uno."
  },
  "disable": {
    "action": "Deshabilitar",
    "title": "Deshabilitar «{name}»",
    "description": "La pantalla quedará bloqueada y dejará de mostrar el código de marcación en menos de 15 segundos.",
    "note": "Conserva su sesión: al habilitarlo recupera el standby sin volver a teclear un código.",
    "reasonLabel": "Motivo (opcional)",
    "reasonHelp": "Queda en la auditoría. Hasta 500 caracteres."
  },
  "enable": {
    "action": "Habilitar",
    "title": "Habilitar «{name}»",
    "description": "El marcador vuelve a operar en su sede.",
    "note": "Si su pantalla sigue conectada recupera el standby sola; si ya no hay sesión, te mostraremos un código nuevo.",
    "siteInactive": "La sede está inactiva"
  },
  "detail": {
    "back": "Volver a Marcadores",
    "sessionTitle": "Sesión del marcador",
    "sessionNone": "Todavía ningún dispositivo canjeó su código.",
    "sessionNoneHelp": "Genera un código y escríbelo en la pantalla que quieras convertir en marcador.",
    "sessionReplaced": "Sesión reemplazada el {date}: otra pantalla canjeó un código de este marcador.",
    "codeTitle": "Código de activación",
    "codeNone": "Sin código emitido",
    "codeStatus": "Estado",
    "codeExpires": "Vence el",
    "autonomousTitle": "Períodos sin conexión",
    "autonomousNone": "Sin períodos registrados",
    "keyDeliveredYes": "Sí",
    "keyDeliveredNo": "Todavía no",
    "never": "Sin señal registrada"
  },
  "autonomous": {
    "description": "Tramos en los que la pantalla siguió mostrando su código sin conexión con Fermin.",
    "caption": "Períodos sin conexión del marcador",
    "startedAt": "Inicio",
    "endedAt": "Fin",
    "duration": "Duración",
    "frames": "Frames emitidos",
    "marks": "Marcas verificadas",
    "source": "Origen",
    "sourceValue": {
      "REPORTED": "Reportado",
      "INFERRED": "Inferido"
    },
    "ongoing": "En curso",
    "openBadge": "Modo sin conexión en curso",
    "error": "No pudimos cargar los períodos sin conexión.",
    "durationSeconds": "{seconds} s",
    "durationMinutes": "{minutes} min {seconds} s",
    "durationHours": "{hours} h {minutes} min"
  },
  "codeStatus": {
    "PENDING": "Pendiente",
    "USED": "Usado",
    "EXPIRED": "Vencido",
    "REVOKED": "Revocado"
  },
  "toast": {
    "created": "Marcador creado",
    "updated": "Cambios guardados",
    "codeIssued": "Código de activación generado",
    "unlinked": "Marcador desvinculado",
    "disabled": "Marcador deshabilitado",
    "enabled": "Marcador habilitado"
  },
  "notices": {
    "inactiveSite": "Los marcadores de una sede inactiva quedan deshabilitados; habilítalos uno a uno tras reactivar la sede."
  },
  "sites": {
    "link": "Ver marcadores de esta sede"
  }
}
